import { useTranslation } from "react-i18next";

export default function HeroSection() {
  const { t } = useTranslation();

  return (
    <section className="relative w-full h-[500px] md:h-[620px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Soft%20minimalist%20fashion%20lifestyle%20flat%20lay%20composition%20with%20neutral%20beige%20and%20cream%20toned%20clothing%20items%20including%20folded%20sweaters%20leather%20accessories%20and%20sneakers%20arranged%20on%20a%20warm%20textured%20linen%20surface%20with%20soft%20natural%20daylight%20casting%20gentle%20shadows%20clean%20editorial%20aesthetic%20with%20organic%20composition%20and%20airy%20atmosphere&width=1600&height=900&seq=pandabuy-hero-2026&orientation=landscape"
        alt="PandabuySpreadsheet Fashion Lifestyle Collection"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/40"></div>

      <div className="relative z-10 w-full px-4 md:px-6">
        <div className="max-w-3xl mx-auto text-center">
          <h1 className="text-2xl md:text-4xl lg:text-5xl font-heading font-bold text-white leading-tight mb-4 md:mb-6">
            {t("hero.title")}
          </h1>
          <p className="text-sm md:text-base text-white/85 max-w-xl mx-auto mb-6 md:mb-8 leading-relaxed">
            {t("hero.subtitle")}
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-3 md:gap-4 mb-6">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="w-full sm:w-auto px-8 py-3 rounded-lg text-sm font-semibold bg-primary-500 text-background-50 hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              {t("hero.cta.pandabuy")}
            </a>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="w-full sm:w-auto px-8 py-3 rounded-lg text-sm font-semibold bg-background-50/90 text-foreground-900 hover:bg-background-50 transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              {t("hero.cta.buynow")}
            </a>
          </div>

          <p className="text-xs md:text-sm text-white/60">{t("hero.trust")}</p>
        </div>
      </div>
    </section>
  );
}